function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Heading } from '@domain-group/fe-co-allhomes-design-system';
import AllhomesListingCard from '@domain-group/fe-co-allhomes-listing-card';
import { ExternalLinkIcon } from '@domain-group/fe-co-icon';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import NewDevelopmentListings from '../new-development-listings/new-development-listings';
import * as styles from './new-development-parent-details.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DEFAULT_NUM_CHILD_LISTINGS = 4;
var NewDevelopmentParentDetails = _ref => {
  var title = _ref.title,
    childListings = _ref.childListings,
    newDevelopmentWebsite = _ref.newDevelopmentWebsite;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAllAvailableProperties = _useState2[0],
    setShowAllAvailableProperties = _useState2[1];
  var toggleAvailableProperties = () => setShowAllAvailableProperties(!showAllAvailableProperties);
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var visibleChildListings = showAllAvailableProperties || childListings.length <= DEFAULT_NUM_CHILD_LISTINGS ? childListings : childListings.slice(0, DEFAULT_NUM_CHILD_LISTINGS);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Heading, {
    title: title
  }), ___EmotionJSX(NewDevelopmentListings, {
    listings: visibleChildListings
  }), childListings.length > DEFAULT_NUM_CHILD_LISTINGS && ___EmotionJSX(Button, {
    appearance: "outline",
    onClick: toggleAvailableProperties
  }, showAllAvailableProperties ? 'Show fewer properties' : 'Show all available properties'), newDevelopmentWebsite && ___EmotionJSX("a", {
    css: styles.cardLink,
    href: newDevelopmentWebsite,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: () => sendEvent('parent-new-dev-website-link-click')
  }, ___EmotionJSX("span", null, "Visit Development Website"), ___EmotionJSX(ExternalLinkIcon, {
    css: styles.cardLinkIcon
  })));
};
NewDevelopmentParentDetails.propTypes = {
  childListings: PropTypes.arrayOf(PropTypes.shape(AllhomesListingCard.propTypes)),
  title: PropTypes.string,
  newDevelopmentWebsite: PropTypes.string
};
NewDevelopmentParentDetails.defaultProps = {
  childListings: [],
  title: 'Properties in this project',
  newDevelopmentWebsite: undefined
};
export default NewDevelopmentParentDetails;